import React from "react";
import PlanSuggestionAnimation from "../../../components/PlanSuggestionAnimation/PlanSuggestionAnimation";
import {subscribeToPlanWithModal} from '../../../modules/PlanService';
import {PLAN_TAGS} from "../../../models/constants";

export default function FreePlan({showMainModal}) {
  const onUpgrade = () => {
    subscribeToPlanWithModal(PLAN_TAGS.PRO, showMainModal);
  };
  return (
    <div className="kt-portlet__body kt-portlet__body--fluid justify-content-center">
      <div className="text-center">
        <PlanSuggestionAnimation/>
        <h2>Facturación ARCA</h2>
        <p>Para poder facturar tus consultas, es necesario contar con un plan pago.</p>
        <button onClick={onUpgrade} className="btn btn-elevate btn-pill btn-lg btn-brand">Contratar</button>
      </div>
    </div>
  );
}
